import { saveAs } from 'file-saver';
import React, { Component } from 'react';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import Table from '../../../components/Table/table.component';
import { CENTRAL_DOACOES_PERMISSIONS } from '../../../constants/permissions';
import downloadService from '../../../services/downloadService';

export default class VisualizarModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			termosRecebimento: [],

		};
		this.columns = [];
		this.actions = [];
	}

	componentDidMount() {
		const { transacao } = this.props;
		if (transacao.tipoTransacao === 'SAIDA') {
			this.setState({ termosRecebimento: [transacao.termoRecebimento] });
		}

		this.columns = [
			{ id: 0, title: 'Termo de recebimento', property: 'nome' },
		];

		this.actions = [
			{
				id: 0,
				name: 'Download do arquivo',
				icon: 'fas fa-download',
				action: item => this.downloadFile(item),
			},
		];
	}

	setNomeCampoOficio = (codigo) => {
		if (codigo === 'PARCIALMENTE_ATENDIDO') {
			return 'Parcialmente';
		}
		if (codigo === 'ATENDIDO') {
			return 'Totalmente';
		}

		return '--';
	}

	downloadFile = async (documento) => {
		const { data: arquivo } = await downloadService.download(documento);
		const blob = new Blob([arquivo]);
		saveAs(blob, documento.nome);
	};

	render() {
		const {
			props: {
				isOpenVisualizar,
				handleCloseVisualizarTransacao,
				transacao,
			},
			state: {
				termosRecebimento,
			},
		} = this;

		return (
			<WidgetModalForm
				textCancelar='Fechar'
				initialValues={transacao}
				title='Visualizar transação'
				isOpen={isOpenVisualizar}
				cancelar={handleCloseVisualizarTransacao}
				modalConfirmarCancelar={false}
				size='lg'
				iconCancelar='fas fa-times'
				isVisualizarTransacao
				dataAlteracao={transacao.dataAlteracao}
			>
				<ModalFormContext.Consumer>
					{({ values }) => (
						<div>
							{values.tipoTransacao === 'ENTRADA' && (
								<div className='row'>
									<div className='col-md-6'>
										<strong>Item:</strong>
										<p>{values.itemDoacao.unidadeDeExibicao}</p>
									</div>{/* .col-md-6 */}
									<div className='col-md-6'>
										<strong>Tipo de transação:</strong>
										<p>Entrada</p>
									</div>{/* .col-md-6 */}
									<div className='col-md-6'>
										<strong>Saldo anterior:</strong>
										<p>{values.quantidadeAnterior}</p>
									</div>{/* .col-md-6 */}
									<div className='col-md-6'>
										<strong>Quantidade:</strong>
										<p>{values.quantidade}</p>
									</div>{/* .col-md-6 */}
									<div className='col-md-6'>
										<strong>Saldo atual:</strong>
										<p>{values.saldo}</p>
									</div>{/* .col-md-6 */}
									<div className='col-md-6'>
										<strong>Data de entrada:</strong>
										<p>{values.dataCadastro}</p>
									</div>{/* .col-md-6 */}
								</div>
							)}
							{values.tipoTransacao === 'SAIDA' && (
								<div>
									<div className='row'>
										<div className='col-md-6'>
											<strong>Item:</strong>
											<p>{values.itemDoacao.unidadeDeExibicao}</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Tipo de transação:</strong>
											<p>Saída</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Saldo anterior:</strong>
											<p>{values.quantidadeAnterior}</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Quantidade:</strong>
											<p>{values.quantidade}</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Saldo atual:</strong>
											<p>{values.saldo}</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Data de saída:</strong>
											<p>{values.dataSaida}</p>
										</div>{/* .col-md-6 */}
										<div className='col-md-6'>
											<strong>Tipo de retirada:</strong>
											<p>{values.oficioDestino ? 'Ofício' : 'Ocorrência'}</p>
										</div>{/* .col-md-6 */}

										{values.oficioDestino && (
											<React.Fragment>
												<div className='col-md-6'>
													<strong>Ofício atendido:</strong>
													<p>{this.setNomeCampoOficio(values.codigoStatusOficio)}</p>
												</div>{/* .col-md-6 */}
												<div className='col-md-12'>
													<strong>Ofício:</strong>
													<p>{values.oficioDestino.nomeOficio}</p>
												</div>{/* .col-md-6 */}
											</React.Fragment>
										)}
										{values.ocorrenciaDestino && (
											<React.Fragment>
												<div className='col-md-6'>
													<strong>Evento:</strong>
													<p>{values.ocorrenciaDestino.eventoAdverso.nome}</p>
												</div>{/* .col-md-12 */}

												<div className='col-md-6'>
													<strong>Município:</strong>
													<p>{values.ocorrenciaDestino.municipio.nome}</p>
												</div>{/* .col-md-6 */}

												<div className='col-md-6'>
													<strong>Data do evento:</strong>
													<p>{values.ocorrenciaDestino.data}</p>
												</div>{/* .col-md-6 */}
											</React.Fragment>
										)}
									</div>{/* .row */}
									<div className='row'>
										<Table
											isPageNumber={false}
											acoesSingleButton
											className='text-left'
											columns={this.columns}
											actions={this.actions}
											data={termosRecebimento}
											emptyMessage='Não há registros cadastrados.'
											emptyColSpan={this.columns.length + 1}
											maxCharactersShown={75}
											permission={CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR}
										/>
									</div>{/* .row */}
								</div>
							)}
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
